import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './translations/en.json';
import fr from './translations/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      // lookupStorage: "i18nextLng"
    },
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
    },
    returnNull: false,
    fallbackLng: 'en',
    debug: false,
    // lng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    keySeparator: '/',
    saveMissing: true,
  });

export default i18n;
